module.exports = __webpack_public_path__ + "img/Partners 9.e0102baa.png";